export default function namingValidator(type: string, value?: string) {
  if (!type) return false;

  if (type === 'string_literal' && (!value || value?.length === 0)) {
    return false;
  }

  if (type === 'publish_date' && (!value || value?.length === 0)) {
    return false;
  }

  return true;
}
